// extracted by mini-css-extract-plugin
export default {"-large":"label-module__-large--VnmLg","label":"label-module__label--eGYjB","noMargin":"label-module__noMargin--J8R6z"};